export default __webpack_public_path__ + "static/media/job_offer1_l.75b205aa.jpg";